import axios  from "axios";


const BASE_URL = 'https://testapi.royalarabian.com/';
// const BASE_URL = 'http://localhost:34567/';

export default axios.create({
    baseURL: BASE_URL
});
export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    headers: { 
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
        'Access-Control-Allow-Origin': "*",
           
},
    withCredentials: true
});